exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ow4b31VtDkl68{padding-bottom:14px}._2mLvEfJVISZPkl{display:flex;flex-direction:row;justify-content:left;align-items:center;word-break:break-word;word-wrap:break-word;overflow-wrap:break-word}@media only screen and (max-width:750px){._2mLvEfJVISZPkl{flex-direction:column;align-items:center;justify-content:center;text-align:center}}._2QqL_Q9bUOuCGo{margin:4px 4px 4px -14px}@media only screen and (max-width:750px){._2QqL_Q9bUOuCGo{margin:0}}._2oSOH8o5CmZ1vo{margin-top:22px;color:#172b4d;font-size:16px;font-weight:600;letter-spacing:-.006em;line-height:20px;margin-top:24px}.hE81HXNhE-jEd-{color:#172b4d;font-size:14px;font-weight:400;line-height:20px}._28awfk-qWaFk5e{margin-top:16px;margin-bottom:22px}._28awfk-qWaFk5e a{color:#fff;font-weight:500}", ""]);

// exports
exports.locals = {
	"largeTeamBoardsBannerPadding": "_3ow4b31VtDkl68",
	"largeTeamBoardsBanner": "_2mLvEfJVISZPkl",
	"teamBoardsBannerImage": "_2QqL_Q9bUOuCGo",
	"teamBoardsBannerHeader": "_2oSOH8o5CmZ1vo",
	"teamBoardsBannerParagraph": "hE81HXNhE-jEd-",
	"teamBoardsButton": "_28awfk-qWaFk5e"
};